var tw = tw || {};
tw.ConditionsReportsPrint = function () {
	var _log = false,
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),//'/snowreport',
		reportType = '',
		reportSubcode = '',
		reportTypeEnum = {
			trail: 'trail',
			fallcolor: 'fallcolor',
			snowmobile: 'snowmobile',
			downhill: 'downhill',
			crosscountry: 'crosscountry'
		},
		baseZoom = 7,
		mobileZoom = 6,
		mobileCenter = null,
		centerLocation = null,
		useZoom = null,
		useCenterLocation = null,
		countyLayer = null,
		partialCounties = "",
		wiBounds = null,
		countyData = null,
		mapOptions = null,
		map = null;


	/**
	 * (RE)Initialize Map, only called once
	 * Get Counties Shape data before initializing map
	 * @param {*} report
	 * */
	var initializeMap = function (report, subcode) {
		if (_log) console.log('initializeMap()');

		mobileCenter = new Microsoft.Maps.Location(44.80282, -90.07542);
		centerLocation = mobileCenter; // start with desktop
		countyLayer = new Microsoft.Maps.EntityCollection();
		countyData = $("[data-countydata]").data("countydata");
		reportType = $("[data-reporttype]").data("reporttype");
		reportSubcode = $("[data-reportsubcode]").data("reportsubcode");

		if (_log) console.log('reportType:', reportType);
		if (_log) console.log('reportSubcode:', reportSubcode);

		wiBounds = Microsoft.Maps.LocationRect.fromEdges(47.382830, -99.858254, 42.131071, -80.932511); //(TL:YY, TL:XX, TR:YY, TR:XX)//47.382830, -95.858254, 42.131071, -85.932511

		useZoom = mobileZoom;
		useCenterLocation = mobileCenter;


		mapOptions = {
			mapTypeId: Microsoft.Maps.MapTypeId.grayscale, //aerial,//canvasDark//grayscale
			maxBounds: wiBounds,
			//bounds: wiBounds,
			zoom: useZoom, //baseZoom,
			center: useCenterLocation, //centerLocation,
			enableSearchLogo: false,
			showScalebar: false,
			showDashboard: false,
			useInertia: false,
			disableKeyboardInput: true,
			disablePanning: false, //mobile.matches, // - remove all panning for MOBILE ONLY except when using the compass buttons
			liteMode: true
		};


		map = new Microsoft.Maps.Map('#map', mapOptions);
		map.entities.clear();

		Microsoft.Maps.loadModule('Microsoft.Maps.AdvancedShapes', {
			callback: getCountiesPercentPeak
		});

		// if(reportType == 'snowmobile'){
		// 	$('.js-condition-fair').addClass('hidden');
		// } else {
		// 	if($('.js-condition-fair').length) $('.js-condition-fair').removeClass('hidden');
		// }
		//console.log('$(.js-condition-fair).length', $('.js-condition-fair').length, reportType);


	};



	/**
	 * Get Counties Percent Peak
	 */
	var getCountiesPercentPeak = function () {
		if (_log) console.log(basePath + '/getallcountiespercentpeak');
		if (_log) console.log('getCountiesPercentPeak()11', reportType);
		if (reportType == "snowmobile") {
			$.ajax({
				url: basePath + '/getallpartiallyclosedcounties',
				data: {
					"reportType": reportType
				},
				type: "POST",
				async: false,
				success: function (data) {
					partialCounties = data;
				},
				error: function (xhr, status, error) {
					console.log(xhr, status, error);
				},
				complete: function () {
					//console.log('getallpartiallyclosedcounties.complete');
				}
			});
		}



		$.ajax({
			url: basePath + '/getallcountiespercentpeak',
			data: {
				"reportType": reportType,
				"subcodeName": reportSubcode
			},
			type: "GET",
			success: function (data) {
				
				addCounties(data);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			},
			complete: function () {
				//if (_log) console.log('getCountiesPercentPeak.complete');
			}
		});
	};







	/**
	 * Add Counties Geometry polygons to stage, attach handlers
	 * @param {*} data 
	 */
	var addCounties = function (data) {
		if (_log) console.group('ConditionsReportsMap.addCounties()', data);
		//if (_log) console.log('reportType:', reportType);

		countyLayer.LayerName = "Counties";
		var percentData = data;
		for (var i = 0; i < countyData.length; i++) { //countyData.length
			var feature = countyData[i];
			var geometry = feature.Value;

			var percentPeak = 0.0;
			var color;
			percentPeak = jQuery.grep(percentData, function (d) {
				return (d.Key == feature.Key);
			})[0];
			//if (_log) console.log('percentPeak.before', percentPeak);

			var mOpacity = .75; //decimal value between 0 and 1. If a value between 1 and 255 is specified, as was done in Bing Maps V7, it will be divided by 255.

            if (reportType == 'trail') {
				if (typeof percentPeak === "undefined") {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				} else if (percentPeak.Value < 0) {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				} else if (percentPeak.Value <= 25) {
					color = new Microsoft.Maps.Color(mOpacity, 123, 119, 116);//closed
				} else if (percentPeak.Value <= 50) {
					color = new Microsoft.Maps.Color(mOpacity, 36, 55, 9);//#243709;//poor
				} else if (percentPeak.Value <= 75) {
					color = new Microsoft.Maps.Color(mOpacity, 72, 110, 18);//#486E12;//fair
				} else if (percentPeak.Value <= 100) {
					color = new Microsoft.Maps.Color(mOpacity, 108, 165, 27);//#6ca51b;//good
				} else {
					color = new Microsoft.Maps.Color(mOpacity, 108, 165, 27);//#6ca51b;//good
				}
			} else if (reportType == 'fallcolor') {
				if (typeof percentPeak === "undefined") {
					color = new Microsoft.Maps.Color(mOpacity, 139, 69, 19);//brown//8B4513
				} else if (percentPeak.Value <= 0) {
                    color = new Microsoft.Maps.Color(mOpacity, 143, 172, 27);//green//8FAC1B
				} else if (percentPeak.Value <= 25) {
					color = new Microsoft.Maps.Color(mOpacity, 143, 172, 27);//green//8FAC1B
				} else if (percentPeak.Value <= 50) {
					color = new Microsoft.Maps.Color(mOpacity, 255, 177, 0);//yellow//#ffb100
				} else if (percentPeak.Value <= 75) {
					color = new Microsoft.Maps.Color(mOpacity, 247, 113, 0);//orange//#f77100
				} else if (percentPeak.Value <= 100) {
					color = new Microsoft.Maps.Color(mOpacity, 228, 31, 0);//red//#e41f00
				} else {
					color = new Microsoft.Maps.Color(mOpacity, 139, 69, 19);//brown//8B4513
				}
			} else {
				if (typeof percentPeak === "undefined") {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				} else if ((reportType == reportTypeEnum.snowmobile || reportType == reportTypeEnum.downhill) && jQuery.inArray(feature.Key, partialCounties) >= 0) {					
					color = new Microsoft.Maps.Color(mOpacity, 185, 184, 185);//idk what this is for
				} else if (percentPeak.Value <= 0) {
					color = new Microsoft.Maps.Color(mOpacity, 104, 100, 97);
				} else if (percentPeak.Value <= 25) {
					color = new Microsoft.Maps.Color(mOpacity, 199, 232, 234);//poor//c7e8ea
				} else if (percentPeak.Value <= 50) {
					color = new Microsoft.Maps.Color(mOpacity, 133, 209, 212);//fair//85d1d4
				} else if (percentPeak.Value <= 75) {
					color = new Microsoft.Maps.Color(mOpacity, 48, 146, 168);//good//3092a8
				} else if (percentPeak.Value <= 100) {
					color = new Microsoft.Maps.Color(mOpacity, 0, 77, 113);//excellent//004d71
				} else {
					color = new Microsoft.Maps.Color(mOpacity, 255, 255, 255);
				}
			}
			//if (_log) console.log('color:', color);

			$.each(geometry, function (index, poly) {
				// draw only the first (exterior) polygon
				var locations = [];
				$.each(poly[0], function (cindex, coord) {
					var location = new Microsoft.Maps.Location(coord[0], coord[1]);
					locations.push(location);
				});
				var polygon = new Microsoft.Maps.Polygon(locations, {
					fillColor: color,
					strokeColor: new Microsoft.Maps.Color(mOpacity, 0, 0, 0),
					strokeThickness: parseFloat(0.5),
					name: feature.Key
				});

				polygon.Name = feature.Key;
				countyLayer.push(polygon);
			});

		}

		if (_log) console.groupEnd();

		map.layers.insert(countyLayer);

	}





	return {
		initializeMap: initializeMap
	}

}();